import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import AuthenticationService from '../backend/AuthenticationService'; 

export const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => (
        AuthenticationService.isUserLoggedIn()
            ? <Component {...props} />
            : <Redirect to={{ pathname: '/loginPage', state: { from: props.location } }} />
    )} />
)

export default PrivateRoute;